// FleetSubscriptionModal - Payment integrations discontinued
// Stub component to prevent build errors

export interface PersonalData {
  full_name: string;
  email: string;
  company_name: string;
  password: string;
}

export interface SelectedPlan {
  id: string;
  name: string;
  price_monthly: number;
  price_yearly?: number;
  billing_period: 'monthly' | 'yearly';
}

export interface PaymentData {
  method: 'card' | 'pix' | 'boleto';
  result?: any;
}

interface FleetSubscriptionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function FleetSubscriptionModal({ open, onOpenChange }: FleetSubscriptionModalProps) {
  // Payment integrations discontinued - redirect to contact
  return null;
}
